import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useWorkspacePanel } from '../../panels/hooks/use-workspace-panel';
import { useEntityPanelManager } from '../../panels/entity-panels/monitored-entities/state/entity-panel-manager';
import { useSetExpandablePanelSize } from '../../panels/expandable-panel-size';
import { useEventMetadataStore } from './event-metadata';
import { EventPanelFormType } from '@mark43/cad-api';
import { useCallImport } from '../tabs/ani-ali-e911/use-call-import';
import { usePhoneCallForEvent } from '../tabs/ani-ali-e911/get-phone-call-for-event';
import { useFormContext } from 'react-hook-form';

export const EventManagerRegister = observer(function EventManagerRegister(props: {
    clearEvent: () => void;
    generatePDF: () => void;
    generateRen: () => void;
    saveEvent: () => void;
    transmitEvent: () => void;
}) {
    const eventPanelManager = useEntityPanelManager();
    const workspacePanel = useWorkspacePanel();
    const eventMetadata = useEventMetadataStore().state.metadata;
    const eventForm = useFormContext<EventPanelFormType>();
    const setEventPanelSize = useSetExpandablePanelSize();
    const selectedCall = usePhoneCallForEvent();
    const callImport = useCallImport(!!workspacePanel.linkedEntityId);
    useEffect(() => {
        eventPanelManager.setEventPanel(workspacePanel.uuid, {
            eventId: eventMetadata?.eventId,
            form: eventForm,
            phoneCall: eventMetadata?.eventPhoneCall,
            workspacePanel,
            metadata: eventMetadata,
            clearEvent: props.clearEvent,
            generatePDF: props.generatePDF,
            generateRen: props.generateRen,
            saveEvent: props.saveEvent,
            transmitEvent: props.transmitEvent,
            callImport: {
                importReportingPartyName() {
                    if (!selectedCall) {
                        return;
                    }
                    callImport.importReportingPartyName(selectedCall);
                },
                importReportingPartyPhoneNumber() {
                    if (!selectedCall) {
                        return;
                    }
                    callImport.importReportingPartyPhoneNumber(selectedCall);
                },
                importAddress() {
                    if (!selectedCall) {
                        return;
                    }
                    callImport.importAddress(selectedCall);
                },
                importGps() {
                    if (!selectedCall) {
                        return;
                    }
                    callImport.importGps(selectedCall);
                },
                importGpsOrAddress() {
                    if (!selectedCall) {
                        return;
                    }
                    callImport.importGpsOrAddress(selectedCall);
                },
                importAll() {
                    if (!selectedCall) {
                        return;
                    }
                    callImport.importAll(selectedCall);
                },
            },
            setEventPanelSize,
        });
        return () => {
            eventPanelManager.removeEventPanel(workspacePanel.uuid);
        };
    }, [
        eventForm,
        eventPanelManager,
        workspacePanel,
        setEventPanelSize,
        eventMetadata,
        props.saveEvent,
        props.transmitEvent,
        callImport,
        selectedCall,
        props.clearEvent,
        props.generatePDF,
        props.generateRen,
    ]);
    return null;
});
